import { makeAutoObservable, toJS } from "mobx";
import SequencesManager from "react-sdk/haxelibs/SequencesManager";
import DataManager from "react-sdk/haxelibs/DataManager";
import SoundPlayer from "react-sdk/SoundPlayer";
import AppState, { POPUPS, SCREENS } from "./AppState";
import Minigames from "./Minigames/Minigames";
import SaveGame from "./SaveGame";
import Catalogue from "./Catalogue/Catalogue";
import PopupsManager from "react-sdk/PopupsManager";
import Minigame from "./Minigames/Minigame";
import ObjectivesLib from "react-sdk/haxelibs/ObjectivesLib";
import Ftues from "./Ftues";

class SequenceScenario {
  /** @type {succubus_sequences_Sequence} */
  mainSeq = null;
  //currentElement = null;
  onEnd = null;

  constructor() {
    makeAutoObservable(this);
  }

  init() {


    // NOTE ceci sont les actions/getters appelés depuis les fichiers .data de scénario

    DataManager.scriptManager.registerAction("executeSequence", (fileId, lineId, done) => {
      this.playSequence(fileId, lineId, done)
    }, false, true);


    DataManager.scriptManager.registerAction("showDialSequence", (fileId, lineId, done) => {
      AppState.dials.playSequence(fileId, lineId, done);
    }, false, true);


    DataManager.scriptManager.registerAction("unlockCatalogue", (catalogId, done) => {
      if (AppState.skipCatalog) {
        Catalogue.unlock(catalogId);
        done();
      } else
        Catalogue.unlock(catalogId, () => {
          setTimeout(() => done(), 10);
        });
    }, false, true);
    DataManager.scriptManager.registerAction("unlockCatalogues", (catalogIdsArray, done) => {
      if (AppState.skipCatalog) {

        Catalogue.multiUnlock(catalogIdsArray);
        done();
      } else {

        Catalogue.multiUnlock(catalogIdsArray, () => {
          setTimeout(() => done(), 10);
        });

      }
    }, false, true);



    DataManager.scriptManager.registerAction("showPlaceholderPopup", (text, done) => {
      PopupsManager.open(POPUPS.NOTIF, {
        title: "PLACEHOLDER",
        text: text,
        onClose: () => {
          PopupsManager.close(POPUPS.NOTIF);
          done();
        }
      })
    }, false, true);


    DataManager.scriptManager.registerFunction("isEvaluation", () => {
      return AppState.isEvaluation;
    }, false);

    DataManager.scriptManager.registerAction("endChapter", () => {
      // if (AppState.isEvaluation && AppState.currentModule == 3)
      //   AppState.showEndScreen();
      // else
        AppState.goBackToModulesChoiceScreen();
    }, false, false);
    
    DataManager.scriptManager.registerAction("showFTUE", (id, done) => {
      if (Ftues.hasBeenViewed(id))
        done()
      else
        PopupsManager.open(POPUPS.FTUE, id, () => {
          if (id !== "warning_evaluation") // cas particulier : on veut afficher ça à plusieurs moments
            Ftues.addViewed(id)
          if (id == "ftue_catalogue") {
            Catalogue.forceClickBtn = true;
            Catalogue.forceClickCB = done;
          } else
            done()
        })
    }, false, true);

    DataManager.scriptManager.registerAction("showMinigameIntroScreen", (id, done) => {
      if (AppState.skipAct)
        done()
      else {
        let mg = Minigames.get(id);
        if (mg)
          PopupsManager.open(POPUPS.MINIGAME_INTRO, mg, done)
        else
          done();
      }
    }, false, true);

    DataManager.scriptManager.registerAction("showMinigame", (id, done) => {
      if (AppState.skipAct) {
        Minigames.skipAutoWin(id)
        done()
      } else {
        Minigames.play(id, done)
        //console.log(Minigames.history);
      }
    }, false, true);

    
    DataManager.scriptManager.registerAction("showMinigameStars", (id, done) => {
      if (AppState.skipAct)
        done()
      else {
        let mg = Minigames.get(id);
        if (mg)
          PopupsManager.open(POPUPS.MINIGAME_STARS, mg, done)
        else
          done();
      }
    }, false, true);

    DataManager.scriptManager.registerAction("computeModuleResult", (mgIds) => {
      AppState.computeModuleResult(mgIds)
    }, false, false);
    DataManager.scriptManager.registerFunction("getModuleStars", (id) => {
      let result = AppState.getLastModuleResult(id);
      if (result.stars != null)
        return result.stars;
      else
        return 0
    }, false);

    DataManager.scriptManager.registerAction("showModuleStars", (id) => {
      PopupsManager.open(POPUPS.MODULE_STARS, id)
    }, false, false);
    DataManager.scriptManager.registerAction("hideModuleStars", () => {
      PopupsManager.close(POPUPS.MODULE_STARS)
    }, false, false);
    DataManager.scriptManager.registerAction("waitModuleStarsClosed", (dataContent, done) => {
      AppState.moduleDebriefText = dataContent.line.getEvaluated("Text")
      AppState.moduleDebriefOnClose = () => {
        AppState.moduleDebriefText = null
        AppState.moduleDebriefOnClose = null
        done()
      }
    }, true, true);



    DataManager.scriptManager.registerAction("saveGame", (done) => {
      SaveGame.save()
      done()
    }, false, true);

    DataManager.scriptManager.registerAction("playSfx", (id) => {
      SoundPlayer.playSound(id)
    }, false, false)

    DataManager.scriptManager.registerAction("lockHUD", (val) => {
      AppState.lockHud = val
    }, false, false)


    DataManager.scriptManager.registerAction("setChapterStep", (stepId) => {
      let triggerVal = "SetChapterStep-" + stepId
      if (AppState.isEvaluation)
        triggerVal += "_eval"
      AppState.reaxe_api.toHaxe("game", "triggerScript", { trigger : "Standard", triggerValue : triggerVal })
    }, false, false);

    DataManager.scriptManager.registerAction("refreshObjectives", (dirty, done) => {
      console.log("RefreshObjectives (dirty : " + dirty + ")")
      if (dirty) {
        AppState.objectives.dirtyRefresh();
        done();
      } else
        AppState.objectives.refresh(() => {console.log("RefreshObjectives done"); done()});
    }, false, true);

  }

  addFile(fileId) {
    SequencesManager.createFileFromId(fileId);
  }

  playSequence(fileId, lineId, onEnd) {

    this.mainSeq = SequencesManager.playElement(fileId, lineId);
    if (this.mainSeq) {
      this.onEnd = onEnd;
      this.next();
    } else
      onEnd();
  }

  next() {
    this.mainSeq.next(element => {
      //this.currentElement = element
      if (element)
        this.next();
      else
        this.quit();
    });
  }

  quit() {
    //SoundPlayer.playSound("music_map");
    this.mainSeq = null;
    //this.currentElement = null;
    //AppState.dials.deleteAllCharacters();

    //AppState.soloObjectives.refresh()

    // ObjectivesLib.refresh();
    if (this.onEnd) this.onEnd();

    this.onEnd = null;
  }
}

export default new SequenceScenario();
